import moment from 'moment';

const month = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul","Ago","Set","Out","Nov","Dez"]

export const getMonthAndYear = (date) => {
  const data = new Date(date)
  
  return `${month[data.getMonth()]}/${data.getFullYear()}`
};

export const getDateAndMonth = (date) => {
  const data = new Date(date)
  
  return `${data.getDate()}/${month[data.getMonth()]}`
};

export const getDateToPT  = (date) => {
  const data = new Date(date)
  
  return data.toLocaleDateString('pt-BR', {timeZone: 'UTC'})
}

export const getDuration = (initialDate, finalDate) => {
 
  const diff = moment(finalDate).diff(moment(initialDate));

  const duration = moment.duration(diff);

  var result = Math.floor(duration.asHours()) + moment.utc(diff).format(":mm:ss");
  
  return result
}

export const getDateIsBefore = (date) => {
  const dueDate = new Date(date)
  const currentDate = new Date()
  const isBefore = moment(dueDate).isBefore(currentDate)

  return isBefore
}

export const dateFormat = (data) => {
  const dateFormat = `${data.getFullYear()}-${addZero(data.getMonth() + 1)}-${addZero(data.getDate())}`

  return dateFormat;
}

const addZero = (num) => {
  if(num <=9) {
    return `0${num}`;
  }

  return num;
}